const STATUS = {
    IDLE: 'IDLE',
    PENDING: 'PENDING',
    RESOLVED: 'RESOLVED',
    REJECTED: 'REJECTED',
    MUTATING: 'MUTATING',
    REFETCHING: 'REFETCHING',
    STALE: 'STALE',
}

export const RequestStatus = {
    status: (status) => ({
        isIdle: status === STATUS.IDLE,
        isPending: status === STATUS.PENDING,
        isResolved: status === STATUS.RESOLVED,
        isRejected: status === STATUS.REJECTED,
        isMutating: status === STATUS.MUTATING,
        isRefetching: status === STATUS.REFETCHING,
        isStale: status === STATUS.STALE,
        isReady: ![STATUS.IDLE, STATUS.PENDING, STATUS.REJECTED].includes(status),
        shouldFetch: [STATUS.IDLE, STATUS.STALE].includes(status),
        status,
    }),
    ...STATUS,
}
